/* app/js/src/components/calendar/dtmf-popover/dtmf-popover.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.button {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.button:focus {
  outline-color: #ffffff;
}
.button:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.button {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.trigger {
  display: flex;
  align-items: center;
  width: 348px;
  height: 55px;
  background-color: white;
  cursor: pointer;
  margin-bottom: 6px;
}
.trigger .text {
  display: flex;
  align-items: center;
  margin-left: 19px;
  font-size: 12px;
  color: #2dbbfc;
  font-weight: 600;
}
.trigger .text.plus-sign {
  font-size: 24px;
}
.popover-container {
  padding: 15px 15px 15px 30px;
  width: 335px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
}
.title {
  color: #2dbbfc;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 15px;
}
span {
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
}
span.space-bottom {
  margin-bottom: 10px;
}
.button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  width: 80px;
  height: 30px;
  font-weight: bold;
  background-color: #2dbbfc;
}
/*# sourceMappingURL=dtmf-popover.component.css.map */
